import React from 'react';
import { AnalyticsCard } from '../../analyticsModule/components/AnalyticsCard/AnalyticsCard';
import { useAverageOrderValueReportCard } from '../../hooks/reportCards/useAverageOrderValueReportCard';
import { useSalesByCountryReportCard } from '../../hooks/reportCards/useSalesByCountryReportCard';
export const DefaultAnalytics = () => {
    const averageOrderValueReport = useAverageOrderValueReportCard();
    const salesByCountryReportCard = useSalesByCountryReportCard();
    return (React.createElement(React.Fragment, null,
        React.createElement(AnalyticsCard, { ...averageOrderValueReport }),
        React.createElement(AnalyticsCard, { ...salesByCountryReportCard })));
};
